/* eslint-disable */
const mediaBucketUrl = process.env.NEXT_PUBLIC_MEDIA_BUCKET_URL;

export const getTextureThumbnailUrl = (textureName: string): string =>
  textureName && `${mediaBucketUrl}textures-thumbnails/${textureName}.jpg`;
